var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"controlchart"}},[_c('b-card',[_c('highcharts',{staticStyle:{"margin-left":"20px","padding-left":"0px"},attrs:{"constructor-type":'chart',"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }